import {
  GET_PLAYER_SCORE_LOADING,
  GET_PLAYER_SCORE_SUCCESS,
  GET_PLAYER_SCORE_ERROR,
  GET_MINIMAL_PLAYERS_LOADING,
  GET_MINIMAL_PLAYERS_SUCCESS,
  GET_MINIMAL_PLAYERS_ERROR,
} from "../../../constant/actionTypes";

const getMinimalPlayerReducer = (state = {}, action) => {
  switch (action.type) {
    case GET_MINIMAL_PLAYERS_LOADING: {
      let obj = {
        loading: true,
      };
      return obj;
    }
    case GET_MINIMAL_PLAYERS_SUCCESS: {
      let obj = {
        loading: false,
        data: action.response,
      };
      return obj;
    }
    case GET_MINIMAL_PLAYERS_ERROR: {
      let obj = {
        loading: false,
        status: action.response,
      };
      return obj;
    }
    default:
      return state;
  }
};

export default getMinimalPlayerReducer;
